// extracted by mini-css-extract-plugin
module.exports = {"videosWrapper":"topper_videosWrapper__341sF","topText":"topper_topText__2UyL-","scrollerBar":"topper_scrollerBar__3qTU1","videosBanner":"topper_videosBanner__3Hx2x"};